import React from 'react';
import { Drawer, List, Typography, IconButton, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DrawerMenuItem from './menu-item/menu-item';
import { Menu } from './styles';

const MobileDrawerMenu = ({ isOpen, onClose, menuTitle, menuItems }) => {
  const toggleDrawerMenu = () => event => {
    if (event) {
      onClose();
    }
  };

  return (
    <Drawer
      anchor="bottom"
      open={isOpen}
      onClose={toggleDrawerMenu(false)}
      ModalProps={{
        disableEscapeKeyDown: true,
        disableBackdropClick: false
      }}
      PaperProps={{
        style: {
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16
        }
      }}
    >
      <Menu container spacing={2} alignItems="center">
        <Grid item xs={2}>
          <IconButton onClick={() => onClose(false)}>
            <CloseIcon />
          </IconButton>
        </Grid>
        <Grid item xs={8} textAlign="center">
          <Typography>{menuTitle}</Typography>
        </Grid>
        <Grid item xs={2} />
      </Menu>
      <List>
        {menuItems.map((item, index) => (
          <DrawerMenuItem
            key={index}
            ItemName={item.name}
            onClickItem={item.onClick}
            ItemIcon={item.icon}
          />
        ))}
      </List>
    </Drawer>
  );
};

export default MobileDrawerMenu;
